export default __webpack_public_path__ + "static/media/logo_.44b2a349.png";